var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3334 56.25V21.75L54.3334 39L31.3334 56.25ZM39 0.666687C33.966 0.666687 28.9813 1.65821 24.3305 3.58464C19.6797 5.51107 15.4538 8.33468 11.8943 11.8943C4.70537 19.0832 0.666687 28.8334 0.666687 39C0.666687 49.1666 4.70537 58.9169 11.8943 66.1058C15.4538 69.6654 19.6797 72.489 24.3305 74.4154C28.9813 76.3418 33.966 77.3334 39 77.3334C49.1666 77.3334 58.9169 73.2947 66.1058 66.1058C73.2947 58.9169 77.3334 49.1666 77.3334 39C77.3334 33.966 76.3418 28.9813 74.4154 24.3305C72.489 19.6797 69.6654 15.4538 66.1058 11.8943C62.5462 8.33468 58.3204 5.51107 53.6696 3.58464C49.0187 1.65821 44.034 0.666687 39 0.666687Z",
    fill: "#F7921E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector8);
export default __webpack_public_path__ + "static/media/Vector (8).a6298c831de6d677bf4b2b710c41dc10.svg";
export { ForwardRef as ReactComponent };